import { FocusZone, FocusZoneDirection, FocusZoneTabbableElements } from "@fluentui/react/lib/FocusZone";
import { Callout, DirectionalHint } from "@fluentui/react/lib/Callout";

import { useSuggenstionList } from "./UseSuggestionList";
import { Suggestion } from "./Suggestion";
import { useSuggestionListStyles } from "./UseSuggestionListStyles";
import { IWithSearchContextProps, WithSearchContext } from "../../SearchContext";

export const SuggestionList = WithSearchContext((props: IWithSearchContextProps): JSX.Element => {
  const {
    isCallOutVisible, isCalloutFocused, onDismiss, focusZoneRef, searchRef
  } = props;

  const styles = useSuggestionListStyles();
  const suggestionList = useSuggenstionList();

  if (!isCallOutVisible) {
    return null;
  }

  return (
    <Callout
      className={styles.root}
      isBeakVisible={false}
      target={searchRef.current}
      onDismiss={onDismiss}
      directionalHint={DirectionalHint.bottomLeftEdge}
      directionalHintForRTL={DirectionalHint.bottomRightEdge}
      setInitialFocus={isCalloutFocused}
      doNotLayer
    >
      <FocusZone
        direction={FocusZoneDirection.bidirectional}
        handleTabKey={FocusZoneTabbableElements.all}
        componentRef={focusZoneRef}
      >
        {suggestionList.map((suggestion) => (
          <Suggestion key={suggestion} suggestion={suggestion} />
        ))}
      </FocusZone>
    </Callout>
  );
});
